import { render, staticRenderFns } from "./AIAgent.PendingAttachments.vue?vue&type=template&id=78757bb2&lang=pug"
import script from "./AIAgent.PendingAttachments.vue?vue&type=script&lang=js"
export * from "./AIAgent.PendingAttachments.vue?vue&type=script&lang=js"
import style0 from "./AIAgent.PendingAttachments.vue?vue&type=style&index=0&id=78757bb2&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports